/* =====================================================================
   Adli tatil (yargı tatili) kuralları — 20 Temmuz – 31 Ağustos (dahil).
   SAF mantık (React'sız); motora `kesinlesmeHesaplayici` tarafından enjekte edilir.

   Rejim ayrımı (kullanıcı kararı):
     'kapali' → adli tatil uygulanmaz (ör. AYM bireysel başvuru — AYM tatile tabi değil)
     'hmk'    → HMK m.104 / İYUK m.8/3: uzama +1 HAFTA (7 gün) — idari yargı süreleri de bunu kullanır
     'cmk'    → CMK m.331: uzama +3 GÜN

   İki hal (kullanıcının verdiği kurallar):
     (ii) Süre hiç başlamamış — süre başlangıcı (tebliğ+1) adli tatil içindeyse:
          süre adli tatilde işlemez, 1 Eylül'den itibaren TAM süre kadar işler.
          (rejimden bağımsız; 7 gün → 7 Eylül)
     (i)  Süre başlamış, doğal son gün adli tatile düşüyorsa:
          31 Ağustos + uzama(rejim) → HMK 7 Eylül / CMK 3 Eylül.
   Her iki halde sonuç ayrıca hafta sonu/resmî-dinî tatil için ilk iş gününe taşınır (motorda).
   ===================================================================== */

import { addDays, parseIso, sonGunHesapla } from './isGunuHesap';

export const REJIMLER = ['kapali', 'hmk', 'cmk'];

export const REJIM_UZAMA = { hmk: 7, cmk: 3 }; // gün

export const REJIM_ETIKET = {
  kapali: 'Adli tatil yok',
  hmk: 'HMK/İYUK (+1 hafta)',
  cmk: 'CMK (+3 gün)',
};

export const REJIM_KISA = {
  kapali: 'Kapalı',
  hmk: 'HMK/İYUK +1 hafta',
  cmk: 'CMK +3 gün',
};

/** Verilen ISO tarih adli tatil aralığında mı (20 Tem – 31 Ağu, dahil)? Yıldan bağımsız. */
export function adliTatildeMi(iso) {
  const d = parseIso(iso);
  if (!d) return false;
  const ay = d.getMonth() + 1;
  const gun = d.getDate();
  if (ay === 8) return true;            // Ağustos tümüyle
  if (ay === 7 && gun >= 20) return true; // 20–31 Temmuz
  return false;
}

/**
 * Adli tatil kuralını uygular ve uzatma ÖNCESİ (ilk iş gününe taşımadan önceki) son günü döndürür.
 * @returns { sonGun, uygulandi, tur: 'baslangic'|'bitis'|null }
 */
export function adliTatilUygula(hamSonGun, baslangic, sure, birim, rejim) {
  if (rejim !== 'hmk' && rejim !== 'cmk') {
    return { sonGun: hamSonGun, uygulandi: false, tur: null };
  }
  // (ii) Süre başlangıcı (tebliğ+1) adli tatildeyse → 1 Eylül'den tam süre kadar.
  if (adliTatildeMi(baslangic)) {
    const yil = parseIso(baslangic).getFullYear();
    const sonGun = sonGunHesapla(`${yil}-08-31`, sure, birim); // 31 Ağu + süre = 1 Eyl başlangıçlı
    return { sonGun, uygulandi: true, tur: 'baslangic' };
  }
  // (i) Doğal son gün adli tatildeyse → 31 Ağustos + uzama(rejim).
  if (adliTatildeMi(hamSonGun)) {
    const yil = parseIso(hamSonGun).getFullYear();
    const sonGun = addDays(`${yil}-08-31`, REJIM_UZAMA[rejim]);
    return { sonGun, uygulandi: true, tur: 'bitis' };
  }
  return { sonGun: hamSonGun, uygulandi: false, tur: null };
}
